import React from "react";
import ImageLinkRow from "./ImageLinkRow";
import SocialLinkRow from "./SocialLinkRow";

// The editable list of links; renders an image row or a social row per field.
const LinkList = ({
  inputFields,
  dragIndex,
  onChange,
  onLinkBlur,
  onPickImage,
  onRemove,
  onDragStart,
  onDragEnd,
  onDrop,
  compact,
  t,
}) => (
  <div>
    <label className="block text-xs font-semibold uppercase tracking-wide text-slate-400 mb-3">
      {t("Link")}
    </label>
    <div className="space-y-3">
      {inputFields.map((input, index) => {
        if (input.type === "image") {
          return (
            <ImageLinkRow
              key={input.uid}
              input={input}
              index={index}
              onChange={onChange}
              onLinkBlur={onLinkBlur}
              onPick={onPickImage}
              onRemove={onRemove}
              onDragStart={onDragStart}
              onDragEnd={onDragEnd}
              onDragOver={(event) => event.preventDefault()}
              onDrop={onDrop}
              dragging={dragIndex === index}
              t={t}
            />
          );
        }
        return (
          <SocialLinkRow
            key={index}
            input={input}
            index={index}
            onChange={onChange}
            onLinkBlur={onLinkBlur}
            onRemove={onRemove}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onDragOver={(event) => event.preventDefault()}
            onDrop={onDrop}
            dragging={dragIndex === index}
            compact={compact}
            t={t}
          />
        );
      })}
    </div>
  </div>
);

export default LinkList;
